export const ENVIRONMENTS = {
  LOCAL: 'local',
};

// Payment type flags
export const CHECK = 'check';
export const CASH = 'cash';
export const CARD = 'card';
export const WIRE = 'wire_payment';
export const PAYLINK = 'paylink';

export const PAYMENT_TYPE = {
  CARD_PAYMENT: 'Card Payment',
  CASH_PAYMENT: 'Cash Payment',
  CHECK_PAYMENT: 'Check Payment',
  WIRE_PAYMENT: 'Wire Payment',
};

export const CARD_PAYMENT_TYPES = {
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
};

export const CHECK_TYPE = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
  MONEY_ORDER: 'money_order',
  CASHIERS_CHECK: 'cashiers_check',
};

export const CC_READER_TYPE = {
  TRANCLOUD: 'trancloud',
  DC_DIRECT: 'dc_direct',
  MAGTEK: 'magtek',
};

export const ORDER_STATUS = {
  SUCCESSFUL: 'successful',
  OPENED: 'opened',
  VOIDED: 'voided',
  VOID_PENDING: 'void_pending',
  INCOMPLETE: 'incomplete',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  HOLD: 'hold',
  REFUNDED: 'refunded',
  PAYLINK_SENT: 'paylink_sent',
  PAYLINK_COMPLETED: 'paylink_completed',
};

export const PAYMENT_CANCELLATION_STATUS = {
  PROCESSING: 'processing',
  ASSISTANCE_REQUIRED: 'assistance_required',
};

export const TRANSACTION_STATUS = {
  SUCCESSFUL: 'successful',
  ERRORED: 'errored',
  CANCELLED: 'cancelled',
  PENDING: 'pending',
  REFUNDED: 'refunded',
  CANCEL_PENDING: 'cancel_pending',
};

// These values match the `cash_action_types` database table in `cb_pos`.
export const CASH_ACTION_TYPES = {
  ADD: 'add',
  DROP: 'drop',
  FLOAT: 'float',
  OPENING_FLOAT: 'opening_float',
  CLOSING_FLOAT: 'closing_float',
  CLOSEOUT: 'closeout',
};

// These are the cash action type display names for use in the UI.
export const CASH_ACTION_TYPES_DISPLAY = {
  [CASH_ACTION_TYPES.ADD]: 'Cash Add',
  [CASH_ACTION_TYPES.DROP]: 'Cash Drop',
  [CASH_ACTION_TYPES.FLOAT]: 'Float',
  [CASH_ACTION_TYPES.OPENING_FLOAT]: 'Opening Float',
  [CASH_ACTION_TYPES.CLOSING_FLOAT]: 'Closing Float',
  [CASH_ACTION_TYPES.CLOSEOUT]: 'Closeout',
};

export const OKTA_LOGOUT_REASON_KEY = 'okta-logout-reason';

export const LOGOUT_REASONS = {
  UNAUTHORIZED: {
    name: 'UNAUTHORIZED',
    value: 'Unauthorized',
    variant: 'error',
  },
  EXPIRED: {
    name: 'EXPIRED',
    value: 'Your session has expired. Please login again.',
    variant: 'error',
  },
  INACTIVITY: {
    name: 'INACTIVITY',
    value: 'You have been logged out due to inactivity.',
    variant: 'info',
  },
  USER_INITIATED: {
    name: 'USER_INITIATED',
    value: 'You have been logged out.',
    variant: 'info',
  },
  CLOSEOUT: {
    name: 'CLOSEOUT',
    value: 'You have successfully closed out of your session.',
    variant: 'info',
  },
  ERROR: {
    name: 'ERROR',
    value: 'There was a problem logging in to your account.',
    variant: 'error',
  },
  TERMINAL_SESSION_NOT_FOUND: {
    name: 'TERMINAL_SESSION_NOT_FOUND',
    value: 'Your terminal session is not found. Please log in again.',
    variant: 'error',
  },
};

export const consoleWarningStyle =
  'background-color: rgba(235, 64, 52, 0.25); color: #eb4034; display: inline-block; margin: 0.5rem; padding: 0.5rem; border: 1px solid #eb4034;';

export const OKTA_OAUTH_ERROR = {
  queryStr: 'error_description=User+is+not+assigned+to+the+client+application.',
  alertBarMsg: 'OAuthError: User is not assigned to the client application.',
};

export const TABLE_MIN_LOADTIME_MS = 450;

export const IMAGE_ORIENTATIONS = {
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
};

export const EMAIL_ADDRESS_FIELD_NAME = 'emailAddress';
export const PHONE_NUMBER_FIELD_NAME = 'phoneNumber';
export const COMPANY_NAME_FIELD = 'company_name';
